<template>

  <div id="wrapperContactForm" class="single_layout">

    <div class="form_row">
      <InputGroup
        ref="FirstName"
        name="FirstName"
        label="First Name"
        rules="required"
        @inputChanged="onInputChange"
      />
    </div>

    <div class="form_row">
      <InputGroup
        ref="LastName"
        name="LastName"
        label="Last Name"
        rules="required"
        @inputChanged="onInputChange"
      />
    </div>

    <div class="form_row company_wrapper">
      <InputGroup
        ref="Company"
        name="Company"
        label="Company Name"
        rules="required"
        @inputChanged="onInputChange"
      />
    </div>

    <div class="form_row">
      <InputGroup
        ref="Email"
        name="Email"
        label="Email"
        rules="required|email"
        @inputChanged="onInputChange"
      />
    </div>

    <div class="form_row">
      <InputPhone
        ref="Phone"
        name="Phone"
        label="Phone"
        rules="required|phone"
        @inputChanged="onInputChange"
      />
    </div>

    <div class="form_row comments">
      <InputTextArea
        ref="commentCapture"
        name="commentCapture"
        label="Comments"
        rules="required"
        @inputChanged="onInputChange"
      />
    </div>

    <div class="form_row">
      <button
        :class="buttonStyle"
        @click="handleSubmitClick"
      >
        Submit Form
      </button>
    </div>

  </div>
</template>

<script>
/* eslint-disable import/no-unresolved */
import InputGroup from '@/components/input-group.vue';
import InputPhone from '@/components/input-phone.vue';
import InputTextArea from '@/components/input-textarea.vue';

export default {
  name: 'ContactLayoutDefault',
  props: {
    onInputChange: { type: Function, required: true },
    onSubmit: { type: Function, required: true },
    onError: { type: Function, required: true },
    buttonStyle: { type: String, required: false, default: 'btn_submit clientpay' },
  },
  components: {
    InputGroup,
    InputPhone,
    InputTextArea,
  },
  methods: {
    handleSubmitClick(event) {
      this.$props.onSubmit(event, this.$refs);
    },
  },
};
</script>
